export default function Footer() {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row text-muted">
          <div className="col-6 text-start">
            <p className="mb-0 text-muted">
              <a href="https://www.cancepro.com" target="_blank" rel="noreferrer">
                <strong>CancePro</strong>
              </a>{' '}
              &mdash; AI-powered decision support for radiologists.
            </p>
          </div>
          <div className="col-6 text-end">
            <ul className="list-inline">
              <li className="list-inline-item">
                <a className="text-muted" href="https://www.cancepro.com/support" target="_blank" rel="noreferrer">
                  Support
                </a>
              </li>
              <li className="list-inline-item">
                <a className="text-muted" href="https://www.cancepro.com/help-center" target="_blank" rel="noreferrer">
                  Help Center
                </a>
              </li>
              <li className="list-inline-item">
                <a className="text-muted" href="https://www.cancepro.com/privacy" target="_blank" rel="noreferrer">
                  Privacy
                </a>
              </li>
              <li className="list-inline-item">
                <a className="text-muted" href="https://www.cancepro.com/terms" target="_blank" rel="noreferrer">
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
